import { Injectable } from '@angular/core';
import { BaseService } from '../../shared/services/base.service';
import * as moment from 'moment';
import { Subject } from 'rxjs';
import { Observable } from 'rxjs/Observable';
import { environment } from '../../../environments/environment';
import { AppConstants } from './../../shared/constants/constants';
import { Utility } from '../../common/utility';

@Injectable()
export class ShareService {
    private userUpdateSubject = new Subject<any>();
    
    constructor(public baseService: BaseService) {

    }

    convertBookingListToLocalTime(list) {
        list.forEach(i => {
            i = this.convertBookingItemToLocalTime(i);
        });
        return list;
    }

    convertBookingItemToLocalTime(item) {
        item['start'] = moment.utc(item['start']).local().format('YYYY-MM-DDTHH:mm:ss');
        item['end'] =  moment.utc(item['end']).local().format('YYYY-MM-DDTHH:mm:ss');
        return item;
    }

    convertBookingDateToUTCString(date) {
        return moment(date).utc().format('YYYY-MM-DDTHH:mm:ss');
    }

    convertBookingDisableDateToLocalTime(list) {
        list.forEach(i => {
            i = moment.utc(i).local().format('YYYY-MM-DDTHH:mm:ss');
        });
        return list;
    }

     /**
     * diapatch event when current user change their infomation
     * @param data : user info data
     */
    announceUserInfoUpdate(data: any) {
        this.userUpdateSubject.next(data);
    }

    /**
     * get current user new info
    */
    getUserInfoUpdate(): Observable<any> {
        return this.userUpdateSubject.asObservable();
    }

    showReport(reportName: string,  data: any,centreId: string) {
        this.baseService.authenticateReportSite(environment.reportServer, environment.authConfig.clientId)
        .subscribe(
          (result) => {
              if (result) {
                this.displayReport(result.json().TokenKeyId, reportName, data,centreId);
              }
          }
      );
    }
    displayReport(reportTokenId: string, reportName: string,  data: any,centreId: string) {
        let params = '&=';
        if (data) {
            for (const key in data) {
              if (data[key] != null && data[key] != undefined && data[key] != NaN && data.hasOwnProperty(key)) {
                if (data[key] instanceof Array) {
                  let paramArray = data[key];
                  for (const item in paramArray) {
                    if (data[key] != null && data[key] != undefined && data[key] != NaN && data.hasOwnProperty(key)) {
                      const strParams = paramArray[item].toString();
                      params += '&' + key + '=' + strParams;
                    }
                  }
                } else {
                  let strParams = data[key].toString();
                  params += '&' + key + '=' + strParams;
                }
              }
            }
          }
    
        const host = environment.reportServer + '/Reports/ReportViewer';
        const timezoneOffset = new Date().getTimezoneOffset();       
        const userName = localStorage.getItem(AppConstants.localStorage.userName);
        let path = host + '?' + AppConstants.reportParameter.reportName + '={0}&' +
                                AppConstants.reportParameter.reportTokenId + '={1}&' +
                                AppConstants.reportParameter.clinicId + '={2}&' +
                                AppConstants.reportParameter.timezoneOffset + '={3}&' +
                                AppConstants.reportParameter.printedBy + '={4}';
        path = Utility.stringFormat(path, [reportName, reportTokenId, centreId, timezoneOffset, userName]);
    
        path += params;
    
        window.open(path, '_blank', 'location=yes');
      }
}




// WEBPACK FOOTER //
// D:/TMB/TMB/MYTMB.UI/src/app/shared/services/share.service.ts